import { css, stack, Z_INDEX_LIBRARY } from '@bts-web/utils-style-engine';

export const summaryWrapperStyles = css({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const overlayStyles = css({
  position: 'fixed',
  insetInlineStart: 0,
  top: 0,
  zIndex: Z_INDEX_LIBRARY.OVERLAY,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  // No token for semi-transparent overlay backdrop color
  background: 'rgba(166, 166, 166, 0.50)',
  backdropFilter: 'blur(6px)',
});

export const cardStyles = css({
  display: 'flex',
  flexDirection: 'column',
  flex: 'auto',
  overflow: 'auto',
  width: { base: '100%' },
  height: { base: '100%', lg: 'auto' },
  maxWidth: { base: '100%', lg: '620px' },
  maxHeight: { base: '100%' },
  background: 'screen_background.primary',
  borderRadius: {
    base: 0,
    lg: 'largeBottomRight',
  },
  boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.15)',
});

export const bodyStyles = css({
  display: 'flex',
  flexDirection: 'column',
  flex: '1',
  overflow: 'auto',
  p: {
    base: 'medium',
    lg: 'large',
  },
});

export const contentStyles = stack({
  direction: 'column',
  flex: '1',
  gap: 'small',
});

export const bottomSectionStyles = stack({
  direction: 'column',
  gap: 'small',
  pt: 'medium',
});
